import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: '\'Inter\', sans-serif',
    body: '\'Inter\', sans-serif',
  },
  colors: {
    brandWhite: {
      500: '#FFFFFF',
      600: '#F5F5F5',
      700: '#F5F5F5',
    },
    brandBackground2: {
      500: '#FBFBFB',
      600: '#EFF0F7',
      700: '#EFF0F7',
    },
    brandGrey: {
      500: '#F5F5F5',
      600: '#F5F5F5',
      700: '#F5F5F5',
    },
    brandPurple: {
      500: '#805AD5',
    },
    brandTextBlack: '#1C1C1C',
    brandTextGrey: '#D8D8D8',
    brandTextGrey2: '#767676',
    brandBackground: '#FBFBFB',
  },
  components: {
    Input: {
      defaultProps: {
        focusBorderColor: 'transparent'
      }
    },
    Drawer: {
      variants: {
        nonblocking: {
          dialog: {
            pointerEvents: 'auto'
          },
          dialogContainer: {
            pointerEvents: 'none'
          }
        }
      }
    }
  }
})

export default theme